export var Size;
(function (Size) {
    Size["md"] = "md";
    Size["lg"] = "lg";
})(Size || (Size = {}));
